import React from "react";
import { MapPin, Phone, Clock, Truck } from "lucide-react";
import { useT } from "@/i18n";

const ICONS = [Truck, Clock, MapPin];

const Montreal = () => {
  const { t } = useT();
  return (
    <section id="montreal" data-testid="montreal-section" className="relative py-24 sm:py-32 bg-[#ece8df] border-y border-black/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-stretch">
          <div className="lg:col-span-5 flex flex-col">
            <div className="overline mb-6 flex items-center gap-3" style={{ color: "#14a497" }}>
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-[#14a497] opacity-75 animate-ping" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#14a497]" />
              </span>
              {t.montreal.avail}
            </div>
            <h2 className="font-display text-4xl sm:text-6xl tracking-tight leading-[1.02] mb-8">
              {t.montreal.h}<br />{t.montreal.h2} <span className="text-[#14a497]">{t.montreal.mtl}</span>
            </h2>
            <p className="text-zinc-700 leading-relaxed mb-10 max-w-md text-lg">{t.montreal.sub}</p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-black/10 border border-black/10 mb-10">
              {t.montreal.stats.map(([label, value], i) => {
                const Icon = ICONS[i];
                return (
                  <div key={i} className="bg-[#ece8df] p-5">
                    <Icon className="w-4 h-4 text-[#ea7a1f] mb-3" strokeWidth={1.75} />
                    <div className="text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-1">{label}</div>
                    <div className="font-display text-sm tracking-tight">{value}</div>
                  </div>
                );
              })}
            </div>

            <a
              href="tel:5145941482"
              data-testid="montreal-call-button"
              className="group inline-flex items-center justify-between gap-6 bg-[#ea7a1f] hover:bg-[#f08b34] text-white font-bold px-7 py-6 transition-all duration-300 hover:translate-y-[-3px] pulse-ring mt-auto"
            >
              <div className="text-left">
                <div className="text-[10px] tracking-[0.3em] uppercase opacity-80">{t.montreal.cta}</div>
                <div className="font-display text-2xl mt-1">514-594-1482</div>
              </div>
              <Phone className="w-6 h-6 group-hover:rotate-[15deg] transition-transform" strokeWidth={2.5} />
            </a>
          </div>

          <div className="lg:col-span-7 relative min-h-[480px] border border-black/10 group">
            <iframe
              title="Mily Superior — Mascouche"
              data-testid="montreal-map"
              src="https://www.openstreetmap.org/export/embed.html?bbox=-73.66%2C45.72%2C-73.54%2C45.78&layer=mapnik&marker=45.7475%2C-73.6010"
              className="absolute inset-0 w-full h-full grayscale contrast-[0.85] brightness-[0.95] group-hover:grayscale-0 transition-all duration-700"
              loading="lazy"
            />
            <div className="absolute inset-0 pointer-events-none border border-[#ea7a1f]/0 group-hover:border-[#ea7a1f]/40 transition-colors duration-700" />
            <div className="absolute top-6 left-6 bg-[#faf7f2]/95 backdrop-blur-xl border border-black/10 px-5 py-4 pointer-events-none max-w-xs">
              <div className="overline mb-1.5">{t.montreal.mapOverline}</div>
              <div className="font-display text-lg leading-snug">1366 Avenue De La Gare<br />Mascouche, QC J7K 2Z2</div>
              <div className="mt-2 text-xs text-zinc-600 tracking-wide">{t.montreal.mapServ}</div>
            </div>
            <a
              href="https://www.google.com/maps/search/?api=1&query=1366+Avenue+De+La+Gare+Mascouche+QC+J7K+2Z2"
              target="_blank"
              rel="noreferrer"
              data-testid="open-map-link"
              className="absolute bottom-6 right-6 bg-[#ea7a1f] hover:bg-[#f08b34] text-white font-bold px-5 py-3 text-sm tracking-wide"
            >
              {t.montreal.directions}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Montreal;
